import { getSelectedFromEnums } from "../tools";

export default app => {
  const { model } = app;

  let Collareral = model.define("collareral", {
    pledge_mortgage_owners: {
      type: "Array",
      label: "所属人",
      value: "",
      parse: (val, result) => {
        let res = [];
        let collateralOwnersTab = [];
        let collateralOwners = [];

        val.forEach(owner => {
          const ownerType = Number(owner["owner_type"]);
          let name = "";
          let tagzhCN = "";
          let tagColor = "";

          if (ownerType === 0) {
            // 企业
            name = owner.owner.entinfo.entName || owner.owner.entinfo.ent_name;
            tagzhCN = "企业";
            tagColor = "success";
          } else if (ownerType === 1) {
            // 自然人
            name = owner.owner.entinfo.ent_name;
            tagzhCN = "自然人";
            tagColor = "primary";
          }

          // 所属人名称
          collateralOwnersTab.push({ name, tagzhCN, tagColor });

          // 保证人详情
          collateralOwners.push(owner.owner.entinfo);
        });

        result["collateralOwners"] = collateralOwnersTab;
        result["collateralOwnersDetail"] = collateralOwners;

        return val;
      }
    },
    addons: {
      type: "Array",
      label: "担保物图片",
      value: "",
      parse: (val, result) => {
        result["addons_format"] = (val || []).map(item => item.uuid);

        return val;
      }
    },
    pm_address_1: {
      type: "string",
      label: "地址",
      value: ""
    },
    pm_address_2: {
      type: "string",
      label: "地址",
      value: ""
    },
    pm_address_3: {
      type: "string",
      label: "地址",
      value: ""
    },
    pm_address_4: {
      type: "string",
      label: "地址",
      value: "",
      parse: (val, result) => {
        let { pm_address_1, pm_address_2, pm_address_3 } = result;
        result[
          "pm_address_half"
        ] = `${pm_address_1}${pm_address_2}${pm_address_3}`;
        result[
          "pm_address_full"
        ] = `${pm_address_1}${pm_address_2}${pm_address_3}${val}`;

        return val;
      }
    },
    pm_name: {
      type: "string",
      label: "担保物名",
      value: ""
    },
    pm_object_evaluation: {
      type: "string",
      label: "估价",
      value: "",
      parse: val => {
        return val || "暂无数据";
      }
    },
    pm_object_msg: {
      type: "string",
      label: "担保物情况",
      value: ""
    },
    pm_object_type: {
      type: "number",
      label: "担保物类型",
      value: ""
      // parse: (val, result, enums) => {
      //   let label = "";
      //   let color = "";
      //
      //   if (!enums) {
      //     console.warn("viewmodel: 枚举为空，请检查");
      //   } else {
      //     let res = getSelectedFromEnums(val, enums);
      //     label = res["label"];
      //     color = res["color"];
      //   }
      //
      //   result["statusLabel"] = label;
      //   result["statusColor"] = color;
      //
      //   return val;
      // }
    },
    // 暂未使用
    pm_type: {
      type: "string",
      label: "担保物类型",
      value: "",
      parse: (val, result) => {
        let label = val === "0" ? "质押物" : "抵押物";
        result["pm_type_zhcn"] = label;

        return val;
      }
    },
    pm_guarantee_type: {
      type: "string",
      label: "担保方式",
      value: ""
    },
    pm_object_type_msg: {
      type: "string",
      label: "担保物类型", // 以前的暂时不知道有什么作用
      value: ""
    }
  });

  return Collareral;
};
